import { c as _c } from "react/compiler-runtime";
import { useConfigureBreadcrumbs } from 'record-it-components/hooks/useConfigureBreadcrumbs/useConfigureBreadcrumbs';
import { BreadcrumbsBuilder } from '../../classes/misc/BreadcrumbsBuilder/BreadcrumbsBuilder';
export function useConfigureBreadcrumbsWithBuilder(prepareBuilder) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== prepareBuilder) {
    const builder = new BreadcrumbsBuilder();
    prepareBuilder(builder);
    t0 = useConfigureBreadcrumbs;
    t1 = builder.disable().build();
    $[0] = prepareBuilder;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  t0(t1);
}